/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
type propType = {
  formik: any;
};

const checkAccordionErrors = (props: propType): boolean => {
  const { formik } = props;

  return (
    (formik.touched.postCode && formik.errors.postCode) ||
    (formik.touched.state && formik.errors.state) ||
    (formik.touched.city && formik.errors.city) ||
    (formik.touched.neighborhood && formik.errors.neighborhood) ||
    (formik.touched.address && formik.errors.address) ||
    (formik.touched.residence_type && formik.errors.residence_type) ||
    (formik.touched.residence_number && formik.errors.residence_number) ||
    (formik.touched.proofOfAddress && formik.errors.proofOfAddress)
  );
};

const checkAccordionChecked = (props: propType): boolean => {
  const { formik } = props;
  const accordionError = checkAccordionErrors(props);

  return (
    !accordionError &&
    formik.values.zipcode &&
    formik.values.state &&
    formik.values.city &&
    formik.values.neighborhood &&
    formik.values.address &&
    formik.values.residence_type &&
    formik.values.residence_number &&
    formik.values.proofOfAddress
  );
};

export { checkAccordionChecked, checkAccordionErrors };
